import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import React from 'react';
export var useGetGhostArticlesTitlesSlugs = function useGetGhostArticlesTitlesSlugs(ghostApi) {
  var _React$useState = React.useState([]),
      articles = _React$useState[0],
      setArticles = _React$useState[1];

  React.useEffect(function () {
    var fetchArticles = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var results;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return ghostApi.posts.browse({
                  limit: 'all',
                  fields: 'slug,title'
                });

              case 3:
                results = _context.sent;
                return _context.abrupt("return", results.map(function (_ref2) {
                  var slug = _ref2.slug,
                      title = _ref2.title;
                  return {
                    slug: slug,
                    title: title
                  };
                }).sort(function (a, b) {
                  return a.title.localeCompare(b.title);
                }));

              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](0);
                return _context.abrupt("return", []);

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 7]]);
      }));

      return function fetchArticles() {
        return _ref.apply(this, arguments);
      };
    }();

    fetchArticles().then(function (data) {
      return setArticles(data);
    });
  }, []);
  return articles;
};